// Pure form model for the Settings page's Version card (spec 026, phase-2 task P3).
//
// The doc is what the app's force-update gate reads on launch and foreground
// (App.js: version/r38fOMRZE4ZUL0ltGnza, platform key iosVersion/androidVersion,
// compared against the running build with compareVersions) — so values must be
// dotted numbers ("2.0.0"), and a value higher than the store build locks every
// user of that platform out until they update. The component stays thin: it hands
// the loaded doc and the field edits here and renders {valid, errors, payload};
// payload carries only the fields that actually changed.

export const VERSION_DOC_ID = "r38fOMRZE4ZUL0ltGnza";

export const VERSION_FIELDS = [
  { key: "iosVersion", label: "iOS required version" },
  { key: "androidVersion", label: "Android required version" },
];

const VERSION_RE = /^\d+(\.\d+){0,3}$/;

export const isVersionString = (value) =>
  typeof value === "string" && VERSION_RE.test(value.trim());

export const buildVersionPayload = (docData, edits) => {
  const current = docData || {};
  const safeEdits = edits || {};
  const errors = {};
  const payload = {};

  for (const { key } of VERSION_FIELDS) {
    if (!(key in safeEdits)) continue; // untouched field — not validated, not written
    const raw = safeEdits[key];
    const trimmed = typeof raw === "string" ? raw.trim() : "";
    // Blank where the doc is also blank: the platform simply isn't gated — nothing
    // to validate. Blank where the doc HAS a value is a clear attempt, refused
    // below by isVersionString (lower the version instead of removing the gate).
    if (trimmed === "" && !current[key]) continue;
    if (!isVersionString(trimmed)) {
      errors[key] = "Must be a dotted version number, e.g. 2.0.0";
      continue;
    }
    if (trimmed !== (current[key] || "")) payload[key] = trimmed;
  }

  const valid = Object.keys(errors).length === 0 && Object.keys(payload).length > 0;
  return { valid, errors, payload };
};
